export default [
  {
    path: "complaints",
    name: "complaints",
    component: (): Promise<any> => import(/* webpackChunkName: "complaints" */ "@/views/Admin/ComplaintsView.vue")
  }
];